<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        cols="12"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">SETUP</div>
                        <div class="text-h6 font-weight-bold primary--text">Multi-User Access Generation</div>
                        <div class="text-body-2 grey--text">Generate PINs and Access KEYs for your Teachers, School Staff, Parents / Students</div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- Create /Update Form -->
                        <v-col cols="12" v-if="newform" class="noprint">
                            <v-form v-model="valid" ref="form">
                                <v-container>
                                    <v-row>
                                        <v-col
                                        cols="12"
                                        md="12"
                                        >
                                            <v-select
                                                v-model="form.user_type"
                                                outlined
                                                clearable
                                                :items="['Teacher', 'Student']"
                                                :rules="[v => !!v || 'Select One']"
                                                label="Select User Access Type"
                                                prepend-inner-icon="mdi-account-key-outline"
                                                @change="fetchFormRecords"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="6"
                                        v-if="form.user_type === 'Teacher' || form.user_type === 'Parent'"
                                        >
                                            <v-text-field
                                                outlined
                                                clearable
                                                v-model="form.fullname"
                                                :label="form.user_type +' Last Name'"
                                                :rules="[v => !!v || 'Enter name']"
                                                prepend-inner-icon="mdi-account-outline"
                                                required
                                            ></v-text-field>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="6"
                                        >
                                            <v-select
                                                outlined
                                                clearable
                                                :items="classes"
                                                item-text="class"
                                                item-value="class_id"
                                                :label="form.user_type == 'Teacher' ? 'Assign Class to Teacher' : 'Student Class'"
                                                v-model="form.class_id"
                                                :rules="[v => !!v || 'Class need to be selected!']"
                                                prepend-inner-icon="mdi-google-classroom"
                                                required
                                                @change="fetchStudents()"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="12"
                                        v-if="form.user_type === 'Student'"
                                        >
                                            <v-select
                                                outlined
                                                clearable
                                                :items="students"
                                                item-text="name"
                                                item-value="scs_id"
                                                label="Select Student"
                                                v-model="form.scs_id"
                                                :rules="[v => !!v || 'Student need to be selected!']"
                                                prepend-inner-icon="mdi-account-school-outline"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="6"
                                        v-if="form.user_type === 'Parent'"
                                        >
                                            <v-select
                                                outlined
                                                clearable
                                                :items="students"
                                                item-text="name"
                                                item-value="scs_id"
                                                label="Select Wards belonging to Parent"
                                                v-model="form.scs_id"
                                                :rules="[v => !!v || 'Student(s) need to be selected!']"
                                                prepend-inner-icon="mdi-account-school-outline"
                                                required
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                        cols="12"
                                        md="12"
                                        >
                                        <v-alert text type="info" v-if="form.user_type === 'Teacher'">This Teacher will have access to this Class' scores and results</v-alert>
                                        <v-alert text type="info" v-if="form.user_type === 'Parent'">This Parent will have access to the selected students results</v-alert>
                                        <v-alert text type="info" v-if="form.user_type === 'Student'">This Student will have access to his/her results</v-alert>

                                        <v-btn :disabled="!valid" color="primary" rounded elevation="2"
                                        class="font-weight-bold text-none mr-3" @click="postRecord"
                                        >
                                            Generate Access LOGIN
                                            <v-icon right>mdi-key-plus</v-icon>
                                        </v-btn>
                                        <v-btn text color="secondary" class="text-none" @click="newform = false">
                                            <v-icon left>mdi-arrow-left</v-icon>
                                            Cancel
                                        </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-form>
                        </v-col>
                        <!-- Records -->
                        <v-col cols="12" v-else>
                            <v-btn rounded color="primary" elevation="2" @click="reset" class="font-weight-bold text-none mt-2 mb-4 noprint">
                                <v-icon left>mdi-plus</v-icon>
                                Generate User Access
                            </v-btn>
                            <info-loader-2 v-if="fetchingContent"/>
                            <v-row v-else>
                                <v-col cols="12" md="6" class="noprint">
                                    <v-alert type="info" text>To ensure the security of data, PINS and Serial number generated will <strong>expire after 90 days of generating them or after the first 300 uses.</strong> You can generate another once expired. You are responsible for securing the PINs and KEYs you generate.</v-alert>
                                </v-col>
                                <v-col cols="12" md="6" class="noprint">
                                    <v-alert type="info" text>Teachers generated will be able to record scores and print results for their classes. Students generated will be able to check and print their own results</v-alert>
                                </v-col>
                                <v-col cols="12" class="noprint">
                                    <v-select
                                        v-model="search"
                                        outlined
                                        clearable
                                        :items="['Teacher', 'Student']"
                                        placeholder="Search"
                                        prepend-inner-icon="mdi-filter-variant"
                                        @change="getRecords"
                                        required
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="6" lg="4" v-for="(record, i) in records" :key="i">
                                    <v-card elevation="2" class="rounded-lg credential-card">
                                        <v-card-title class="credential-title">
                                            <v-icon left small color="accent">mdi-account-key-outline</v-icon>
                                            <span v-if="record.user_type == 'Teacher'">Teacher - {{record.clasx}} Class</span>
                                            <span v-if="record.user_type == 'Student'">Student - {{record.student_fullname}}</span>
                                            <span v-if="record.user_type == 'Parent'"> Parent - {{record.fullname}}</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <div class="credential-row">
                                                <span class="credential-label">KEY</span>
                                                <span class="credential-value">{{record.key}}</span>
                                            </div>
                                            <div class="credential-row">
                                                <span class="credential-label">PIN</span>
                                                <span class="credential-value">{{record.pin}}</span>
                                            </div>
                                            <div class="credential-row">
                                                <span class="credential-label">EXPIRES</span>
                                                <span class="credential-value credential-expire">{{record.expire_at}}</span>
                                            </div>
                                            <v-chip small outlined color="primary" class="mt-3">https://mysch.ng/access</v-chip>
                                        </v-card-text>
                                        <v-card-actions class="noprint">
                                            <v-spacer></v-spacer>
                                            <v-btn @click="deleteRecord(record)" icon color="error" small
                                            ><v-icon small> mdi-trash-can-outline </v-icon>
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-btn rounded color="accent" dark elevation="2" v-if="records.length > 0" class="font-weight-bold text-none mt-3 noprint" href="javascript:window.print()">
                                <v-icon left>mdi-printer-outline</v-icon>
                                Print
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HeaderVue from '../../components/Header.vue'
import axios from 'axios';
import InfoLoader2 from '../../components/InfoLoader2.vue';
  export default {
    name: 'GenerateTokens',
    components: {
        HeaderVue,
        InfoLoader2
    },
    mounted() {
       if (!this.authToken) {
           this.$router.push({name: 'Login'})
       }
       this.getRecords()
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        newform: false,
        editBtn: false,
        search: 0,
        form:{},
        records:[],
        classes:[],
        students:[],
        valid: true,
        fetchingContent:true
    }),
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        reset () {
            this.newform = true
            this.form = {}
        },
        getRecords () {
            axios.get(process.env.VUE_APP_BASEURL+'/multiaccess?school_id='+this.school.school_id+'&user_type='+this.search,
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
            })
            .then((response) => {
                this.records =  response.data.data
                this.fetchingContent = false
            })
            .catch((error) => {
                if (error.response?.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'Network Error. Try again later!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchingContent = false;
            });
        },
        postRecord () {
            if(confirm("This is a PREMIUM Feature and will consume 1 TOKEN from your balance")){
                //sent token deduction
                let validation = this.$refs.form.validate()
                if(!validation) {
                    return validation
                }
                let loader = this.$loading.show()
                axios.post(process.env.VUE_APP_BASEURL+'/multiaccess?school_id='+this.school.school_id,this.form,
                {
                    headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then((response) => {
                    this.$toast.success(response.data.message, {
                        timeout: 5000
                    });
                    this.$store.dispatch('fetchTokens', this.school.school_id);
                    this.getRecords()
                    this.newform = false
                })
                .catch((error) => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                        timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        },
        deleteRecord (record) {
            if(confirm("Do you really want to delete?")){
                let loader = this.$loading.show()
                axios.delete(process.env.VUE_APP_BASEURL+'/multiaccess/'+record.access_token+'?school_id='+this.school.school_id,{
                    headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then(response => {
                     this.$toast.success(response.data.message, {
                        timeout: 5000
                    });
                    this.getRecords()
                })
                .catch(error => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        },
        fetchClasses () {
            axios.get(process.env.VUE_APP_BASEURL+'/classes?school_id='+this.school.school_id,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken
                }
            })
            .then((response) => {
                this.classes =  response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
            });
        },
        fetchStudents (){
            axios.get(process.env.VUE_APP_BASEURL+'/students?school_id='+this.school.school_id+'&class_id='+this.form.class_id,
            {
                headers: { 'Authorization': 'Bearer '+this.authToken }
            })
            .then((response) => {
                this.students =  response.data.data
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
            });
        },
        fetchFormRecords(){
            this.form.fullname = null,
            this.form.scs_id = null,
            this.form.class_id = null,
            this.fetchClasses(),
            this.fetchStudents()
        }
    },
  }
</script>

<style scoped>
.credential-card {
    border: 1px solid #ECEFF7;
}
.credential-title {
    font-size: 0.85rem;
    font-weight: 700;
    color: #1E3C72;
}
.credential-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    border-bottom: 1px dashed #E3E8F4;
    font-family: 'Courier New', monospace;
}
.credential-label {
    font-size: 0.7rem;
    letter-spacing: 1px;
    color: #90A4AE;
    font-weight: 700;
}
.credential-value {
    font-weight: 700;
    color: #2E7D32;
}
.credential-expire {
    color: #C62828;
}
</style>

<style>
@media print{
    .noprint {
        display: none !important;
    }
}
</style>
